export default __webpack_public_path__ + "static/media/logo.da9e94af.png";